import { useEffect, useRef } from 'react';
import classNames from 'classnames';
import AddToCartLink from './AddToCartLink';
import { useProductPageContext } from './hooks/useProductPageContext';
import ProductPrice from './sections/main/right/product/ProductPrice';

const BottomBar = () => {
  const { selectedOffer, selectedWarranty, isFetchingSku } =
    useProductPageContext();

  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const content = contentRef.current;
    const root = document.documentElement;

    if (!content) {
      return undefined;
    }

    const setOffset = () => {
      root.style.setProperty(
        '--cookie-banner-offset',
        `${content.offsetHeight}px`,
      );
    };

    setOffset();

    const observer =
      typeof ResizeObserver === 'undefined'
        ? undefined
        : new ResizeObserver(setOffset);

    observer?.observe(content);

    return () => {
      observer?.disconnect();
      root.style.removeProperty('--cookie-banner-offset');
    };
  }, []);

  return (
    <div className="fixed bottom-0 z-[70] w-full bg-white pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1),0_-2px_4px_-2px_rgba(0,0,0,0.1)] lg:hidden">
      <div
        ref={contentRef}
        className={classNames(
          'xl:reebelo-container mx-auto px-5 py-5 xl:px-8',
          {
            'opacity-60': isFetchingSku,
          },
        )}
      >
        <div className="flex items-center justify-between gap-2">
          <ProductPrice />
          <div className="shrink-0 xs:min-w-[200px]">
            <AddToCartLink
              testingId="e2e-pdp-bottom-bar-add-to-cart"
              className="w-full"
              id="bottomBarPurchaseCont"
              offer={selectedOffer}
              selectedWarranty={selectedWarranty}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
